// extracted by mini-css-extract-plugin
export default {"wrapper":"carol_wrapper__Vd3Uy","inside":"carol_inside__x+7g5","links":"carol_links__62rao"};